import React from "react";
import { FIELD_REGISTRY } from "./Config/fieldRegistry";

function ProductPricingInformation({
    formData,
    handleChange,
    handleNumberInput,  
    errors,
    config
}) {
    const fields = config?.fields?.pricing || [];
    console.log("Pricing fields:", config?.fields?.pricing);
    if (fields.length === 0) return null;

    return (
        <div className="card mb-3">
            <div className="card-header">
                <h5>Pricing Information</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {fields.map((fieldName) => {
                        const fieldConfig = FIELD_REGISTRY[fieldName];
                        if (!fieldConfig) return null;
                        const { type, label, required, placeholder } = fieldConfig;
                       if (type === 'select') {
                           let options = fieldConfig.options || [];
                            console.log("Options:", FIELD_REGISTRY.discount_type?.options);
                            // ✅ FIX: Agar options string hai toh empty array karo
                            if (typeof options === 'string') {
                                options = [];
                            }
                            return (
                                <div className="col-md-4 mb-3" key={fieldName}>
                                    <label className="form-label">
                                        {label} {required && <span className="text-danger">*</span>}
                                    </label>
                                    <select
                                        className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                        name={fieldName}
                                        value={formData[fieldName] || ""}
                                       onChange={handleChange} 
                                    >
                                        <option value="">Select {label}</option>
                                        {Array.isArray(options) && options.map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.[fieldName] && (
                                        <div className="invalid-feedback">{errors[fieldName]}</div>
                                    )}
                                </div>
                            );
                        }
                        return (
                            <div className="col-md-4 mb-3" key={fieldName}>
                                <label className="form-label">
                                    {label} {required && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type={type === 'number' || type === 'price' ? 'number' : 'text'}
                                    className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                    placeholder={placeholder || `Enter ${label}`}
                                    name={fieldName}
                                    value={formData[fieldName] || ""}
                                    onChange={type === 'select' ? handleChange : handleNumberInput}
                                    step="0.01"
                                />
                                {errors?.[fieldName] && (
                                    <div className="invalid-feedback">{errors[fieldName]}</div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default ProductPricingInformation;